import { AppAlert, AppTextLink } from '@9b3kuq5phwuk4txw/kiban-react-ui'

export function Alerts() {
  return (
    <AppAlert type='info'>
      <div className='flex flex-row space-x-1'>
        <p>インセンティブに関するお問い合わせは</p>
        <AppTextLink href='https://forms.cloud.microsoft/r/f4X2KELiHx' external>
          こちら
        </AppTextLink>
        <p>からお願いします。</p>
      </div>
    </AppAlert>
  )
}
